<template>
  <div class="customer-address" :class="[address_info.TADR_DEFAUT === 'O' ? 'main-addr' : '']">
    <CustomModal 
    :title="$_('address_modify')"
    :open="open"
    @close-modal="open=false, validate = false">
      <template slot="modal_content">
        <AddressForm @complete="validate = false, open = false" :form_type="form_type" :validate="getValidate" :form="this.$props.address_info" />
      </template>
      <template slot="modal_footer">
        <button class="btn" @click="validate = true">{{$_('validate')}}</button>
      </template>
    </CustomModal>


    <CustomModal 
    :title="$_('delete_address')"
    :open="open_delete"
    :keepratio="true"
    :size="'sm'"
    @close-modal="open_delete=false">
      <template slot="modal_content">
        <p>{{$_('delete_address_question')}}</p>
      </template>
      <template slot="modal_footer">
        <div class="button-bar">
          <button class="btn" @click="vConfirmDelete">{{$_('yes')}}</button>
          <button class="btn" @click="open_delete = false">{{$_('no')}}</button>
        </div>
      </template>
    </CustomModal>

    <span class="customer-society">{{address_info.TNOM}}</span>
    <span class="customer-info">{{address_info.TADR1}}</span>
    <span class="customer-info">{{address_info.TADR2}}</span>
    <span class="customer-info">{{address_info.TADR3}}</span>
    <span class="customer-info">{{address_info.TCPOST}} {{address_info.TVILLE}}</span>
    <span class="customer-info">{{address_info.TLPAYS}}</span>
    <span class="customer-info">{{address_info.TTEL}}</span>

    <div v-if="mode !== 'account' " class="customer-address-choice" :class="selected_addr === true ? 'selected' : ''">
      <span ref="btnAddress" @click="vSelectAddr(address_info.TTYP_ADR)" class="btn">{{$_('choose_this_address')}}</span>
    </div>

    <div class="customer-address-control">
      <div class="control-edit" @click="open = true">
        <span>
          <i class="material-icons">edit</i>
        </span>
      </div>
      <div class="control-delete" v-if="address_info.TADR_DEFAUT === 'N'">
        <span @click="vDeleteAddress">
          <i class="material-icons">delete</i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>

import CustomModal from '@/common/components/widget/Modal/CustomModal';
import AddressForm from '@/modules/client/components/AddressForm';

import customerService from '@/modules/client/services/customerService';

export default {
  name: "Address",
  props: ["address_info", "index", "length", 'new', 'mode', 'pnocl', 'selectedF', 'selectedL'],
  data() {
    return {
      open: false,
      validate: false,
      form_type: 'update',
      open_delete: false,
      selected_addr: false,
      addr_type: '',
    }
  },
  components: {
    CustomModal,
    AddressForm
  }, 
  mounted() {
    
    this.addr_type = this.$props.address_info.TTYP_ADR;
  
    if(this.$props.mode !== 'cart' && this.$props.pnocl !== undefined) {
      customerService.getCustomerAddress('echantillon', this.$props.pnocl)
      .then(res => {
        if(res.data.DS_O !== undefined) {
          this.$store.dispatch('client/SET', {key: 'address', value: res.data.DS_O.OUT});
        }
      })
    }
  },
  computed: {
    getBillingAddress() {
      return this.$store.getters['panier/get_billing_address'];
    },
    getDeliveryAddress() {
      return this.$store.getters['panier/get_delivery_address'];
    },
    getValidate() {
      return this.validate;
    },
    getDisplayDeliveryAddr() {
      return this.$store.getters['panier/get_display_delivery_address'];
    },
    getDisplayBillingAddr() {
      return this.$store.getters['panier/get_display_billing_address'];
    }
  },
  methods: {
    vDeleteAddress() {
      this.open_delete = true
    },
    vConfirmDelete() {
      let form_tmp = {};

      Object.entries(this.$props.address_info).map(arr => {
        if(arr[0] !== 'TLPAYS' && arr[0] !== 'TLPROV') {
          form_tmp[arr[0]] = arr[1];
        }
      })

      // Code suppression
      form_tmp.TTOP_ADR = 'S';

      customerService.sendCustomerAddress(form_tmp)
      .then(res => {

        if(res.data !== undefined && res.data.POK === 1) {

          customerService.getCustomerAddress('account')
          .then(res => {

            if(res.data.DS_O !== undefined) {
              this.$store.dispatch('client/SET', {key: 'address', value: res.data.DS_O.OUT});
            }
          })
        }
      })

      this.open_delete = false;
    },
    vSelectAddr(ttyp_adr) {

      if(ttyp_adr === 'L') {

        // this.$store.dispatch('panier/SET', {key: 'last_selected_addr_l', value: tnlig.TNLIG});

        this.$parent.$children.map(addr => {

          if(
            addr.$data.selected_addr !== undefined &&
            addr.$data.addr_type === 'L'
          ) {
            addr.$data.selected_addr = false
          }
        })
      }
      
      if(ttyp_adr === 'F') {

        // this.$store.dispatch('panier/SET', {key: 'last_selected_addr_f', value: tnlig.TNLIG});

        this.$parent.$children.map(addr => {

          if(
            addr.$data.selected_addr !== undefined &&
            addr.$data.addr_type === 'F'
          ) {
            addr.$data.selected_addr = false
          }
        })
      }

      this.selected_addr = true;

      if(this.$props.mode === 'cart') {
        if(ttyp_adr === 'L') {
          this.$store.dispatch('panier/SET', {key: 'delivery_address', value: this.$props.address_info});
          this.$store.dispatch('panier/SET', {key: 'display_delivery_address', value: this.$props.address_info});
        } else if (ttyp_adr === 'F') {
          this.$store.dispatch('panier/SET', {key: 'billing_address', value: this.$props.address_info});
          this.$store.dispatch('panier/SET', {key: 'display_billing_address', value: this.$props.address_info});
        }
      } else {

        if(ttyp_adr === 'L') {

          this.$store.dispatch("echantillon/SET_HEADER", { key: 'tadr1l', value: this.$props.address_info.TADR1 });
          this.$store.dispatch("echantillon/SET_HEADER", { key: 'tadr2l', value: this.$props.address_info.TADR2 });
          this.$store.dispatch("echantillon/SET_HEADER", { key: 'tadr3l', value: this.$props.address_info.TADR3 });
          this.$store.dispatch("echantillon/SET_HEADER", { key: 'tcpostl', value: this.$props.address_info.TCPOST });
          this.$store.dispatch("echantillon/SET_HEADER", { key: 'tvillel', value: this.$props.address_info.TVILLE });
          this.$store.dispatch("echantillon/SET_HEADER", { key: 'tcpaysl', value: this.$props.address_info.TCPAYS });
          this.$store.dispatch("echantillon/SET_HEADER", { key: 'tcprovl', value: this.$props.address_info.TLPROV });

        } else if (ttyp_adr === 'F') {
         
          this.$store.dispatch("echantillon/SET_HEADER", { key: 'tadr1f', value: this.$props.address_info.TADR1 });
          this.$store.dispatch("echantillon/SET_HEADER", { key: 'tadr2f', value: this.$props.address_info.TADR2 });
          this.$store.dispatch("echantillon/SET_HEADER", { key: 'tadr3f', value: this.$props.address_info.TADR3 });
          this.$store.dispatch("echantillon/SET_HEADER", { key: 'tcpostf', value: this.$props.address_info.TCPOST });
          this.$store.dispatch("echantillon/SET_HEADER", { key: 'tvillef', value: this.$props.address_info.TVILLE });
          this.$store.dispatch("echantillon/SET_HEADER", { key: 'tcpaysf', value: this.$props.address_info.TCPAYS });
          this.$store.dispatch("echantillon/SET_HEADER", { key: 'tcprovf', value: this.$props.address_info.TLPROV });
        }
      }
    }
  },
  watch: {
    getDisplayDeliveryAddr() {
      setTimeout(() => {
        if(this.addr_type === 'L' && this.$store.getters['panier/get_display_delivery_address'].TNOML === this.$props.address_info.TNOM) {
          this.selected_addr = true;
        }
      }, 1000);
    },
    getDisplayBillingAddr() {
      setTimeout(() => {
        if(this.addr_type === 'F' && this.$store.getters['panier/get_display_billing_address'].TNOMF === this.$props.address_info.TNOM) {
          this.selected_addr = true;
        } 
      }, 1000);
    }
  }
};
</script>

<style scoped>
.customer-name,
.customer-society {
  font-family: "Lato";
  font-size: var(--fz-md);
  color: #8b8b8b;
}
.customer-society {
  margin-bottom: 10px;
}
.customer-info {
  font-family: "Lato-Regular";
  line-height: 1.5;
  font-size: var(--fz-md);
  color: #8b8b8b;
}
.customer-info:first-child {
  margin-top: 5px;
}
.customer-address-choice {
  margin-top: 15px;
  position: absolute;
  bottom: 15px;
  left: 15px;
  right: 15px;
}
.customer-address-choice .btn {
  width: 100%;
}
.customer-address-info {
  display: flex;
  flex-direction: column;
}
.customer-address-control {
  position: absolute;
  right: -18px;
}
.customer-address-control div {
  border: solid 1px #8b8b8b;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  margin-bottom: 10px;
}
.customer-address-control div:hover {
  cursor: pointer;
}
.customer-address-control i {
  font-size: 1.3rem;
}
.customer-address {
  display: flex;
  flex-direction: column;
  border: solid 1px #e9e9e9;
  padding: 15px;
  position: relative;
  min-height: 250px;
}
.button-bar {
  display: block;
  text-align: center;
}
.button-bar .btn {
  margin: 0px 10px
}
.main-addr {
  background-color: rgb(247, 247, 247);
  border: solid 1px rgb(237, 237, 237);
}
.customer-address.selected {
  background: green;
}
.customer-address-choice.selected:after {
  content: '\e5ca';
  font-family: 'Material Icons';
  width: 30px;
  height: 30px;
  background-color: rgb(51, 148, 51);
  border-radius: 50%;
  position: absolute;
  right: -10px;
  top: -10px;
  color: #fff;
  font-size: 1.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn {
  text-align: center;
}
</style>